import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'

export const Route = createFileRoute('/_dashboard/site/$id/dashboard/recommendations/')({
  pendingComponent: PendingComponent,
})
